import { ComponentsCTABlock } from '@modules/VanOord.Styleguide/Frontend/content/components/blocks/ctaBlock.sg'
import { ComponentsDownloadBlock } from '@modules/VanOord.Styleguide/Frontend/content/components/blocks/downloadBlock.sg'
import { ComponentsExpandableBlock } from '@modules/VanOord.Styleguide/Frontend/content/components/blocks/expandableBlock.sg'
import { ComponentsGridBlock } from '@modules/VanOord.Styleguide/Frontend/content/components/blocks/gridBlock.sg'
import { ComponentsMediaBlock } from '@modules/VanOord.Styleguide/Frontend/content/components/blocks/mediaBlock.sg'
import { ComponentsOfficeBlock } from '@modules/VanOord.Styleguide/Frontend/content/components/blocks/officeBlock.sg'
import { ComponentsQuoteBlock } from '@modules/VanOord.Styleguide/Frontend/content/components/blocks/quoteBlock.sg'
import { ComponentsTextBlock } from '@modules/VanOord.Styleguide/Frontend/content/components/blocks/textBlock.sg'
import { ComponentsPageheader } from '@modules/VanOord.Styleguide/Frontend/content/components/pageheader.sg'
import { ComponentsSiteheader } from '@modules/VanOord.Styleguide/Frontend/content/components/siteheader.sg'
import * as React from 'react'
import { Widget, any, fromJSX } from 'widgets-for-react'
import { OtherKeyProjectsBlock } from '../fake_data/blocks/OtherKeyProjectsBlock'
import { relatedContentBlock } from '../fake_data/blocks/relatedContentBlock'
import { pressContactBlock, updatesBlock } from '../fake_data/buildingblocks'
import { footer } from '../fake_data/footer'
import {
  detailUpdateHeader,
  expertiseHeader,
  genericHeader,
  projectHeader,
  resultsHeader
} from '../fake_data/pageheader'
import {
  helperPlaceholderSVG,
  styleguideChapter,
  styleguideExample,
  styleguidePart,
  styleguideSection
} from '../helpers.mod'

export const styleguideComponents: Widget<never> =styleguideChapter(
  { type: 'components', slug: 'components', title: 'Design Components', intro: '' })(
      any([
        styleguideSection({
          type: 'components',
          slug: 'components-header',
          title: 'Redesign - Site header',
          intro: ''
        })(fromJSX(() => <ComponentsSiteheader />)),
        styleguideSection({
          type: 'components',
          slug: 'components-pageheader',
          title: 'Redesign - Pageheaders',
          intro: ''
        })(fromJSX(() => <ComponentsPageheader />)),
        styleguideSection({
          type: 'components',
          slug: 'components-cta',
          title: 'Redesign - CTA Block',
          intro: ''
        })(fromJSX(() => <ComponentsCTABlock /> )),
        styleguideSection({
          type: 'components',
          slug: 'components-download',
          title: 'Redesign(ish) - Download Block',
          intro: ''
        })(fromJSX(() => <ComponentsDownloadBlock /> )),
        styleguideSection({
          type: 'components',
          slug: 'components-expandable',
          title: 'Redesign(ish) - Expandable Block',
          intro: ''
        })(fromJSX(() => <ComponentsExpandableBlock /> )),
        styleguideSection({
          type: 'components',
          slug: 'components-grid',
          title: 'Redesign - Grid Block',
          intro: ''
        })(fromJSX(() => <ComponentsGridBlock /> )),
        styleguideSection({
          type: 'components',
          slug: 'components-media',
          title: 'Redesign(ish) - Media Block',
          intro: ''
        })(fromJSX(() => <ComponentsMediaBlock /> )),
        styleguideSection({
          type: 'components',
          slug: 'components-office',
          title: 'Redesign(ish) - Office Block',
          intro: ''
        })(fromJSX(() => <ComponentsOfficeBlock /> )),
        styleguideSection({
          type: 'components',
          slug: 'components-quote',
          title: 'Redesign - Quote Block',
          intro: ''
        })(fromJSX(() => <ComponentsQuoteBlock /> )),
        styleguideSection({
          type: 'components',
          slug: 'components-text',
          title: 'Redesign(ish) - Text Block',
          intro: ''
        })(fromJSX(() => <ComponentsTextBlock /> )),

        styleguideSection({
          type: 'components',
          slug: 'components-others',
          title: 'Other Key Projects Block',
          intro: ''
        })(
          styleguidePart({ title: '', intro: '' })(
            styleguideExample({ showExampleLabel: false, isFullScreen: false })(
              fromJSX(() => OtherKeyProjectsBlock())
            )
          )
        ),
        styleguideSection({
          type: 'components',
          slug: 'components-related',
          title: 'Related Content Block',
          intro: ''
        })(
          styleguidePart({ title: '', intro: '' })(
            styleguideExample({ showExampleLabel: false, isFullScreen: false })(
              fromJSX(() => relatedContentBlock())
            )
          )
        ),
        styleguideSection({
          type: 'components',
          slug: 'components-development',
          title: 'Development Block',
          intro: ''
        })(
          styleguidePart({ title: '', intro: '' })(
            styleguideExample({ showExampleLabel: false, isFullScreen: false })(
              fromJSX(() => (
                // I allready created a block inside developmentBlock.tsx, you can call that directly in here ;)
                <section className="block block--development ls-block-spacing">
                    <div className="block__inner ls-container">
                      <header className="block__header">
                        <h2 className="block__title title--m">Magna Tortor Adipiscing Fusce</h2>
                      </header>
                      <div className="block__content">
                        <ul className="block__list">
                          <li className="block__item item">
                            <img
                              loading="lazy"
                              className="item__icon"
                              alt="icon"
                              src="/frontend/images/icons/image-sustiain-1.svg"
                              width="70"
                              height="70"
                            />
                          </li>
                          <li className="block__item item">
                            <img
                              loading="lazy"
                              className="item__icon"
                              alt="icon"
                              src="/frontend/images/icons/image-sustiain-2.svg"
                              width="70"
                              height="70"
                            />
                          </li>
                          <li className="block__item item">
                            <img
                              loading="lazy"
                              className="item__icon"
                              alt="icon"
                              src="/frontend/images/icons/image-sustiain-3.svg"
                              width="70"
                              height="70"
                            />
                          </li>
                          <li className="block__item item">
                            <img
                              loading="lazy"
                              className="item__icon"
                              alt="icon"
                              src="/frontend/images/icons/image-sustiain-4.svg"
                              width="70"
                              height="70"
                            />
                          </li>
                        </ul>
                      </div>
                    </div>
                </section>
              ))
            )
          )
        ),

        styleguideSection({
          type: 'components',
          slug: 'components-press',
          title: 'Press Block',
          intro: ''
        })(
          any([
            styleguidePart({ title: 'Without image', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                fromJSX(() => pressContactBlock(false))
              )
            ),
            styleguidePart({ title: 'With Image', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                fromJSX(() => pressContactBlock(true))
              )
            )
          ])
        ),
        styleguideSection({
          type: 'components',
          slug: 'components-update',
          title: 'Updates Block',
          intro: ''
        })(
          styleguidePart({ title: '', intro: '' })(
            styleguideExample({ showExampleLabel: false, isFullScreen: false })(
              fromJSX(() => updatesBlock())
            )
          )
        ),

        styleguideSection({
          type: 'components',
          slug: 'components-generic',
          title: 'Update / Careers header',
          intro: ''
        })(
          any([
            styleguidePart({ title: '', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                fromJSX(() => genericHeader())
              )
            )
          ])
        ),
        styleguideSection({
          type: 'components',
          slug: 'components-results',
          title: 'Vacancies / Search results header',
          intro: ''
        })(
          any([
            styleguidePart({ title: '', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                fromJSX(() => resultsHeader())
              )
            )
          ])
        ),
        styleguideSection({
          type: 'components',
          slug: 'components-project',
          title: 'Project header',
          intro: ''
        })(
          any([
            styleguidePart({ title: '', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                fromJSX(() => projectHeader())
              )
            )
          ])
        ),
        styleguideSection({
          type: 'components',
          slug: 'components-expertise',
          title: 'Expertise header',
          intro: ''
        })(
          any([
            styleguidePart({ title: '', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                fromJSX(() => expertiseHeader())
              )
            )
          ])
        ),
        styleguideSection({
          type: 'components',
          slug: 'components-detail',
          title: 'Updates detail page header',
          intro: ''
        })(
          any([
            styleguidePart({ title: '', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                fromJSX(() => detailUpdateHeader())
              )
            )
          ])
        ),
        styleguideSection({ type: 'components', slug: 'components-footer', title: 'Footer', intro: '' })(
          any([
            styleguidePart({ title: '', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(fromJSX(() => footer()))
            )
          ])
        ),

        styleguideSection({ type: 'components', slug: 'components-gallery', title: 'Gallery Block', intro: '' })(
          any([
            styleguidePart({ title: 'Gallery - Close', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                fromJSX(() => (
                    <section className="block block--gallery ls-block-spacing">
                      <div className="block__inner ls-container">
                        <header className="block__header">
                          <h2 className="block__title title--l">Block title</h2>
                          <p className="block__intro">
                            Donec ullamcorper nulla non metus auctor fringilla. Vivamus sagittis lacus vel augue laoreet
                            rutrum faucibus dolor auctor.
                          </p>
                        </header>
                        <div className={'block__content'}>
                          <ul className="gallery" data-gallery-show-more="true">
                            <li className="gallery__item">
                              <button className="gallery__button fit-object" aria-expanded="false">
                                <img
                                  loading="lazy"
                                  src={helperPlaceholderSVG({
                                    shape: { width: 1600, height: 1600, radius: '0', color: '#e8e8e8' },
                                    text: { color: '#1e1e1e', size: '40px', font: 'Open Sans, sans-serif' }
                                  })}
                                  width="1600"
                                  height="1600"
                                  className="gallery__image"
                                  alt="Donec ullamcorper nulla non metus auctor fringilla"
                                />
                                <span className="sr-text">ImageGallery.EnlargedImage</span>
                              </button>
                            </li>
                            <li className="gallery__item">
                              <button className="gallery__button fit-object" aria-expanded="false">
                                <img
                                  loading="lazy"
                                  src={helperPlaceholderSVG({
                                    shape: { width: 1600, height: 1600, radius: '0', color: '#000000' },
                                    text: { color: '#FFFFFF', size: '40px', font: 'Open Sans, sans-serif' }
                                  })}
                                  width="1600"
                                  height="1600"
                                  className="gallery__image"
                                  alt="Donec ullamcorper nulla non metus auctor fringilla"
                                />
                                <span className="sr-text">ImageGallery.EnlargedImage</span>
                              </button>
                            </li>
                            <li className="gallery__item">
                              <button className="gallery__button fit-object has-toggle" aria-expanded="false">
                                <img
                                  loading="lazy"
                                  src={helperPlaceholderSVG({
                                    shape: { width: 1600, height: 1600, radius: '0', color: '#D8D8D8' },
                                    text: { color: '#000000', size: '40px', font: 'Open Sans, sans-serif' }
                                  })}
                                  width="1600"
                                  height="1600"
                                  className="gallery__image"
                                  alt="Donec ullamcorper nulla non metus auctor fringilla"
                                />
                                <div className="gallery__toggle title--m">+1</div>
                              </button>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </section>
                ))
              )
            ),
            styleguidePart({ title: 'Gallery - Open', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: true })(
                fromJSX(() => (
                    <section className="block block--gallery ls-block-spacing">
                      <div className="block__inner ls-container">
                        <header className="block__header">
                          <h2 className="block__title title--l">Block title</h2>
                          <p className="block__intro">
                            Donec ullamcorper nulla non metus auctor fringilla. Vivamus sagittis lacus vel augue laoreet
                            rutrum faucibus dolor auctor.
                          </p>
                        </header>
                        <div className={'block__content'}>
                          <ul className="gallery" data-gallery-show-more="true">
                            <li className="gallery__item">
                              <button className="gallery__button fit-object" aria-expanded="false">
                                <img
                                  loading="lazy"
                                  src={helperPlaceholderSVG({
                                    shape: { width: 1600, height: 1600, radius: '0', color: '#e8e8e8' },
                                    text: { color: '#1e1e1e', size: '40px', font: 'Open Sans, sans-serif' }
                                  })}
                                  width="1600"
                                  height="1600"
                                  className="gallery__image"
                                  alt="Donec ullamcorper nulla non metus auctor fringilla"
                                />
                                <span className="sr-text">ImageGallery.EnlargedImage</span>
                              </button>
                            </li>
                            <li className="gallery__item">
                              <button className="gallery__button fit-object" aria-expanded="false">
                                <img
                                  loading="lazy"
                                  src={helperPlaceholderSVG({
                                    shape: { width: 1600, height: 1600, radius: '0', color: '#000000' },
                                    text: { color: '#FFFFFF', size: '40px', font: 'Open Sans, sans-serif' }
                                  })}
                                  width="1600"
                                  height="1600"
                                  className="gallery__image"
                                  alt="Donec ullamcorper nulla non metus auctor fringilla"
                                />
                                <span className="sr-text">ImageGallery.EnlargedImage</span>
                              </button>
                            </li>
                            <li className="gallery__item">
                              <button className="gallery__button fit-object has-toggle" aria-expanded="false">
                                <img
                                  loading="lazy"
                                  src={helperPlaceholderSVG({
                                    shape: { width: 1600, height: 1600, radius: '0', color: '#D8D8D8' },
                                    text: { color: '#000000', size: '40px', font: 'Open Sans, sans-serif' }
                                  })}
                                  width="1600"
                                  height="1600"
                                  className="gallery__image"
                                  alt="Donec ullamcorper nulla non metus auctor fringilla"
                                />
                                <div className="gallery__toggle title--m">+1</div>
                              </button>
                            </li>
                          </ul>
                        </div>

                        <div id="a11y-lightbox-8" aria-hidden="true" className="lightbox">
                          <div className="lightbox__inner ls-container">
                            <div className="lightbox__nav">
                              <div className="lightbox__nav-inner">
                                <button className="lightbox__close">
                                  <span className="sr-text">ImageGallery.CloseOverlay</span>
                                </button>
                              </div>
                            </div>
                            <figure className="lightbox__figure">
                              <div className="lightbox__visual ls-container">
                                <img
                                  loading="lazy"
                                  className="lightbox__image"
                                  src={helperPlaceholderSVG({
                                    shape: { width: 1680, height: 2000, radius: '0', color: '#e8e8e8' },
                                    text: { color: '#1e1e1e', size: '40px', font: 'Open Sans, sans-serif' }
                                  })}
                                  width="1600"
                                  height="1600"
                                />
                                <figcaption className="lightbox__figcaption block__figcaption">
                                  <p className="lightbox__caption">Maecenas faucibus mollis interdum.</p>
                                </figcaption>
                              </div>
                            </figure>
                            <div className="lightbox__controls">
                              <div className="lightbox__controls-inner">
                                <button className="lightbox__control lightbox__control--previous">
                                  <span className="sr-text">ImageGallery.PreviousImage</span>
                                </button>
                                <button className="lightbox__control lightbox__control--next">
                                  <span className="sr-text">ImageGallery.NextImage</span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                ))
              )
            ),
            styleguidePart({ title: 'Gallery - 2 images only', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                fromJSX(() => (
                    <section className="block block--images ls-container">
                      <div className="block__inner">
                        <header className="block__header">
                          <h2 className="block__title title--l">Block title</h2>
                          <p className="block__intro">
                            Donec ullamcorper nulla non metus auctor fringilla. Vivamus sagittis lacus vel augue laoreet
                            rutrum faucibus dolor auctor.
                          </p>
                        </header>
                        <div className={'block__content'}>
                          <ul className="block__list grid" data-gallery-show-more="true">
                            <li className="grid__item">
                              <button className="grid__visual fit-object" aria-expanded="false">
                                <img
                                  loading="lazy"
                                  src={helperPlaceholderSVG({
                                    shape: { width: 1600, height: 1600, radius: '0', color: '#e8e8e8' },
                                    text: { color: '#1e1e1e', size: '40px', font: 'Open Sans, sans-serif' }
                                  })}
                                  width="1600"
                                  height="1600"
                                  className="gallery__image"
                                  alt="Donec ullamcorper nulla non metus auctor fringilla"
                                />
                                <span className="sr-text">ImageGallery.EnlargedImage</span>
                              </button>
                            </li>
                            <li className="grid__item">
                              <button className="grid__visual fit-object" aria-expanded="false">
                                <img
                                  loading="lazy"
                                  src={helperPlaceholderSVG({
                                    shape: { width: 1600, height: 1600, radius: '0', color: '#000000' },
                                    text: { color: '#FFFFFF', size: '40px', font: 'Open Sans, sans-serif' }
                                  })}
                                  width="1600"
                                  height="1600"
                                  className="gallery__image"
                                  alt="Donec ullamcorper nulla non metus auctor fringilla"
                                />
                                <span className="sr-text">ImageGallery.EnlargedImage</span>
                              </button>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </section>
                ))
              )
            )
          ])
        ),
        styleguideSection({
          type: 'components',
          slug: 'components-text-image',
          title: 'Text with images Block',
          intro: ''
        })(
          any([
            styleguidePart({ title: 'Left', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                fromJSX(() => (
                    <section className="block block--text-image block--image-left">
                      <div className="block__outer ls-container">
                        <div className="block__inner">
                          <div className="block__content">
                            <header className="block__header">
                              <h2 className="block__title title--l">Block title</h2>
                            </header>
                            <ul className="block__list blocklist">
                              <li className="block__item blocklist__item">
                                <p className="block__subtitle">
                                  Van Oord is a family run company that exists for more than 150 years. And we realize
                                  that we would be nowhere without ingenious employees. So to ensure their wellbeing we
                                  have extensive saftey trainings and meticulous procedures.
                                </p>
                                <a className="block__link link">More about our Safety Programme</a>
                              </li>
                              <li className="block__item">
                                <p className="block__subtitle">
                                  Van Oord is a family run company that exists for more than 150 years. And we realize
                                  that we would be nowhere without ingenious employees. So to ensure their wellbeing we
                                  have extensive saftey trainings and meticulous procedures.
                                </p>
                                <a className="block__link link">More about our Safety Programme</a>
                              </li>
                            </ul>
                          </div>
                          <div className="block__visuals">
                            <figure className="block__figure">
                              <div className="block__visual fit-object">
                                <img
                                  src={helperPlaceholderSVG({
                                    shape: { width: 800, height: 800, radius: '0', color: '#e8e8e8' },
                                    text: { color: '#1e1e1e', size: '40px', font: 'Open Sans, sans-serif' }
                                  })}
                                  width="800"
                                  height="800"
                                />
                              </div>
                            </figure>
                            <figure className="block__figure">
                              <div className="block__visual fit-object">
                                <img
                                  src={helperPlaceholderSVG({
                                    shape: { width: 600, height: 600, radius: '0', color: '#000000' },
                                    text: { color: '#FFFFFF', size: '40px', font: 'Open Sans, sans-serif' }
                                  })}
                                  width="600"
                                  height="600"
                                />
                              </div>
                            </figure>
                          </div>
                        </div>
                      </div>
                    </section>
                ))
              )
            ),
            styleguidePart({ title: 'Right', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                  fromJSX(() => (
                    <section className="block block--text-image block--image-right">
                      <div className="block__outer ls-container">
                        <div className="block__inner">
                          <div className="block__content">
                            <header className="block__header">
                              <h2 className="block__title title--l">Block title</h2>
                            </header>
                            <ul className="block__list blocklist">
                              <li className="block__item blocklist__item">
                                <p className="block__subtitle">
                                  Van Oord is a family run company that exists for more than 150 years. And we realize
                                  that we would be nowhere without ingenious employees. So to ensure their wellbeing we
                                  have extensive saftey trainings and meticulous procedures.
                                </p>
                                <a className="block__link link">More about our Safety Programme</a>
                              </li>
                              <li className="block__item">
                                <p className="block__subtitle">
                                  Van Oord is a family run company that exists for more than 150 years. And we realize
                                  that we would be nowhere without ingenious employees. So to ensure their wellbeing we
                                  have extensive saftey trainings and meticulous procedures.
                                </p>
                                <a className="block__link link">More about our Safety Programme</a>
                              </li>
                            </ul>
                          </div>
                          <div className="block__visuals">
                            <figure className="block__figure">
                              <div className="block__visual fit-object">
                                <img
                                  src={helperPlaceholderSVG({
                                    shape: { width: 800, height: 800, radius: '0', color: '#e8e8e8' },
                                    text: { color: '#1e1e1e', size: '40px', font: 'Open Sans, sans-serif' }
                                  })}
                                  width="800"
                                  height="800"
                                />
                              </div>
                            </figure>
                            <figure className="block__figure">
                              <div className="block__visual fit-object">
                                <img
                                  src={helperPlaceholderSVG({
                                    shape: { width: 600, height: 600, radius: '0', color: '#000000' },
                                    text: { color: '#FFFFFF', size: '40px', font: 'Open Sans, sans-serif' }
                                  })}
                                  width="600"
                                  height="600"
                                />
                              </div>
                            </figure>
                          </div>
                        </div>
                      </div>
                    </section>
                  ))
              )
            )
          ])
        )
      ])
    ).never()
